import React, { useState } from 'react'
import { Box, TextField } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { format, startOfToday } from 'date-fns'
import { date, object } from 'yup'

import { themeConWeb } from '../../../util/modernThemeConweb'
import LinkButton from '../../common/LinkButton'
import ButtonSaveCancel from './ButtonSaveCancel'

const TODAY = format(startOfToday(), 'YYYY-MM-DD')

const schema = object().shape({
  endDate: date()
    .nullable()
    .transform((curr, orig) => (orig === '' ? null : curr))
    .min(TODAY, 'End date cannot be in the past.'),
})

const EditableEndDate = ({ defaultValue, submitting, min = TODAY, onSubmit }) => {
  const [editing, setEditing] = useState(false)
  const [value, setValue] = useState(defaultValue ?? '')
  const [validationError, setValidationError] = useState(undefined)

  const handleSubmit = () => {
    schema
      .validate({ endDate: value })
      .then(() => {
        onSubmit(value)
        setEditing(false)
      })
      .catch(({ message }) => {
        setValidationError(message)
      })
  }

  const handleToggleEditMode = () => {
    if (editing) {
      setEditing(false)
      setValidationError(undefined)
      setValue(defaultValue ?? '')
    } else {
      setEditing(true)
    }
  }

  if (submitting) return <Skeleton variant="rect" />

  return (
    <>
      {!editing && (
        <LinkButton color={themeConWeb.color.brandPrimary} onClick={handleToggleEditMode}>
          {defaultValue ? format(defaultValue, 'MM/DD/YYYY') : 'Set date'}
        </LinkButton>
      )}
      {editing && (
        <Box position="relative" width="fit-content">
          <TextField
            id="endDate"
            type="date"
            variant="outlined"
            size="small"
            value={value}
            onChange={e => setValue(e.target.value)}
            inputProps={{ role: 'input', min }}
            helperText={validationError}
            error={Boolean(validationError)}
          />
          <ButtonSaveCancel onSave={handleSubmit} onCancel={handleToggleEditMode} />
        </Box>
      )}
    </>
  )
}

export default EditableEndDate
